import { createRoute } from '@tanstack/react-router'
import { Route as rootRoute } from '@/app/__root'
import { ROUTES } from '@/shared/constants/routes'
import { OnboardingRentersPage } from './page.onboarding-renters'

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: ROUTES.ONBOARDING_RENTERS,
  component: OnboardingRentersPage,
})
